<template>
    <toolbar-option>
        <template slot="primary">
            <select v-bind="value">
                <option value="paper">Paper</option>
            </select>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'google-map-styles',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Map Styles',
            styles: '',
            value: '',
        };
    },

    watch: {
        styles() {
            // @TODO - add this to custom attributes
            this.onOptionChange(this.value);
            this.setChangedData(true);
        },
    },
};
</script>

<style lang="scss" scoped>
.button {
    @extend %button-alt;
    @extend %button-compact;
}
</style>
